import React, { FC } from 'react';
import { Button, Dialog, DialogActions } from '@mui/material';
import { RingMyPhoneLockModalProps } from '../../app/interfaceTypes';
import CardLockComponents from '../ringMyPhone/CardLockComponents';

const RingMyPhoneLockModal: FC<RingMyPhoneLockModalProps> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <CardLockComponents />

      <DialogActions
        sx={{
          px: 3,
          pb: 2,
          borderTop: (theme) => `1px solid ${theme.palette.divider}`,
          justifyContent: 'flex-end'
        }}
      >
        <Button sx={{ mt: 1 }} onClick={onClose} variant="outlined" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RingMyPhoneLockModal;
